import { connect } from 'react-redux';

import ServiceSelect from '../components/ServiceSelect';

import { startRequest } from '../redux/services/actions';

@connect(
  function ({ contacts: { services } }) {
    return {
      services,
    };
  },
  function (dispatch) {
    return {
      getServices: (id) => dispatch(startRequest(id)),
    };
  },
)
export default class ServiceSelectContainer extends ServiceSelect {}
